import React from 'react';

import {
  CreateProductForm,
  CreateProductModalFooter,
  StyledModal,
} from 'common/components';

import { useIXOneCapture } from '../ixone-credit-card/IXOneContext';

import useGetParamsProductCreating from 'hooks/createProductHooks';
import { useMutationCreateProduct } from './hooks';
import { useGetMemberId } from 'hooks';

import { defaultType } from 'pages/qa-spec/constant';

export const IXOneNewProductForm = (props) => {
  const { visible, onCancel, ...otherProps } = props;

  const { memberId } = useGetMemberId();

  const { submitForm, formLoading, resetFormState, ...createProductFormProps } =
    useGetParamsProductCreating({
      modalVisible: visible,
      isEdit: false,
      callApiCallback: () => {},
      memberId: memberId,
      productId: null,
    });

  const modalProps = {
    visible,
    onCancel,
    title: 'New Product',
    width: '85%',
    closable: true,
    maskClosable: false,
    ...otherProps,
  };

  const createProductMutation = useMutationCreateProduct();

  const { onSelectHierarchy, onUpdateSelectedIds } = useIXOneCapture();

  const { form, brick, productCategory, brandId } = createProductFormProps;

  const handleCreateProduct = async () => {
    const values = await form.validateFields();

    const brickCode = brick?.brickCode;
    const brickCodeName = brick?.brickCodeName;
    const visibility = values?.visibility ?? 'Private';
    const type = values?.type ?? defaultType;

    const payload = {
      ...values,
      ...productCategory,
      brandId,
      brickCode,
      brickCodeName,
      visibility,
      memberId,
      type,
    };

    createProductMutation.mutate(payload, {
      onSuccess: (response) => {
        if (response?.isSuccess) {
          const addedProductId = response?.data?.productId;

          onSelectHierarchy((prevState) => ({
            ...prevState,
            [addedProductId]: {
              selectedHierarchy: {},
            },
          }));
          onUpdateSelectedIds(addedProductId);

          resetFormState();
          onCancel();
        }
      },
    });
  };

  return (
    <div>
      <StyledModal
        {...modalProps}
        isLoading={createProductMutation.isLoading}
        loadingContent={{ loadingText: 'Loading' }}
        centered
        footer={
          <CreateProductModalFooter
            onCancel={onCancel}
            onOk={handleCreateProduct}
            okLoading={createProductMutation.isLoading}
          />
        }
      >
        <CreateProductForm
          {...createProductFormProps}
          form={form}
          memberIdBrand={memberId}
        />
      </StyledModal>
    </div>
  );
};
